/**
 * Canonical list of frontend feature flags.
 * This is the single source of truth for valid frontend flag names.
 */
export const FeatureFlags = {
  MatchingQuiz: 'matching_quiz',
  MainscreenJourney: 'mainscreen_journey',
  DocumentsBuilder: 'documents_builder',
  WorkExperienceDescription: 'work_experience_description',
  SynteaChatbot: 'syntea_chatbot',
} as const

export type FeatureFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags]
